<template>
    <div>
        <div>
            <!--OS:-->
            <div class="os-and-browser">
                <div>
                    <span v-if="os === 'Windows'"><windowsIcon /></span>
                    <span v-if="os === 'Mac OS'"><macIcon /></span>
                    <span v-if="os === 'Linux'"><LinuxIcon /></span>
                    <span v-if="os === 'iOS'"><iosIcon /></span>
                    <span v-if="os === 'Android'"><androidIcon /></span
                    ><!--Android[-x86]-->
                </div>
                <div>
                    {{ os }}
                </div>
            </div>
        </div>
        <div>
            <!--Browser:-->
            <div class="os-and-browser">
                <span v-if="browser === 'Chrome'"> <ChromeIcon /></span>
                <span v-if="browser === 'Safari'"> <SafariIcon /></span>
                <span v-if="browser === 'Edge'"> <EdgeIcon /></span>
                <span v-if="browser === 'Firefox'"> <FirefoxIcon /></span>
                <span v-if="browser === 'Opera'"> <OperaIcon /></span>
                <div>
                    {{ browser }} <span style="font-size: 12px">{{ browserVersion }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SafariIcon from "../../../components/svg/SafariIcon.vue";
import ChromeIcon from "../../../components/svg/ChromeIcon.vue";
import EdgeIcon from "../../../components/svg/EdgeIcon.vue";
import OperaIcon from "../../../components/svg/OperaIcon.vue";
import FirefoxIcon from "../../../components/svg/FirefoxIcon.vue";
import androidIcon from "../../../components/svg/AndroidIcon.vue";
import iosIcon from "../../../components/svg/iosIcon.vue";
import LinuxIcon from "../../../components/svg/LinuxIcon.vue";
import macIcon from "../../../components/svg/MacIcon.vue";
import windowsIcon from "../../../components/svg/WindowsIcon.vue";

export default {
    name: "UserAgentInfo",
    components: {
        SafariIcon,
        ChromeIcon,
        EdgeIcon,
        OperaIcon,
        FirefoxIcon,
        androidIcon,
        iosIcon,
        LinuxIcon,
        macIcon,
        windowsIcon,
    },
    props: {
        userAgent: { type: String },
        os: { type: String },
        browser: { type: String },
        browserVersion: { type: String },
    },

    methods: {},
};
</script>

<style scoped>
.os-and-browser {
    display: flex;
    gap: 4px;
}
</style>
